<script lang="ts">
import { ExternalLink } from "@lucide/svelte";
import { Button } from "./ui/button/index.ts";
import * as DropdownMenu from "./ui/dropdown-menu/index.ts";
import {
  type ExternalAppLink,
  externalAppLinks,
  type ExternalAppsTarget,
} from "../lib/externalApps.ts";

let { target }: { target: ExternalAppsTarget } = $props();

function openExternalApp(link: ExternalAppLink): void {
  window.open(link.href, "_blank", "noopener,noreferrer");
}
</script>

<DropdownMenu.Root>
  <DropdownMenu.Trigger>
    {#snippet child({ props })}
      <Button
        {...props}
        type="button"
        variant="outline"
        size="sm"
        class="cursor-pointer"
        aria-label="Open selected place in another app"
      >
        <ExternalLink data-icon="inline-start" />
        Open in…
      </Button>
    {/snippet}
  </DropdownMenu.Trigger>

  <DropdownMenu.Content align="start" class="w-64">
    <DropdownMenu.Group aria-label="External map apps">
      {#each externalAppLinks(target) as link}
        <DropdownMenu.Item onSelect={() => openExternalApp(link)}>
          {link.label}
        </DropdownMenu.Item>
      {/each}
    </DropdownMenu.Group>
  </DropdownMenu.Content>
</DropdownMenu.Root>
